<template>
  <div class="overlay overlay--grow-xl" 
    v-show="modalVisible"
  > 
    <transition name="slideDown"> 

      <div>
        <div ref="target" class="overlay__inner" v-show="modalVisible" @click.stop>
          <div class="app-modal">
            <div class="app-modal__buttons">

              <button class="btn btn-secondary btn-sm"
                @click="printFrame()"
              ><i class="fa fa-print"></i> Print</button>
              <iframe src="/pricing-calculator/dashboard-guide" style="visibility: hidden; height: 1px; width: 1px" name="dashboard-guide"></iframe>

              <button class="btn btn-icon app-modal__close" aria-label="Close"
                @click.prevent="toggleModal"
              ><i class="fa fa-close"></i></button>
            </div>
            <h3 
              class="app-modal__head app-modal__head--main" 
              @mouseenter="moveable.draggable = true"
              @mouseleave="moveable.draggable = false"
            >Dashboard Guide</h3>
            <div class="app-modal__inner align-cntr">
              <img v-bind:src="dashboardGuideImage1" alt="" v-if="dashboardGuideImage1" style="margin-bottom: 20px;">
              <img v-bind:src="dashboardGuideImage2" alt="" v-if="dashboardGuideImage2">
            </div>
          </div>
        </div>

        <Moveable
          className="moveable"
          :target="$refs.target"
          :draggable="moveable.draggable"
          :origin="false"
          @drag="handleDrag"
        />
      </div>

    </transition>
  </div>
</template>

<script>
import Moveable from 'vue3-moveable'

export default {
  props: ['modalVisible'],
  components: {
    Moveable
  },
  data () {
    return {
      moveable: {
        draggable: false,
      }
    }
  },
  computed: {
    dashboardGuideImage1() {
      return window.epb.pages['dashboard'].sections['dashboard-guide']['image-1'].file_url
    },
    dashboardGuideImage2() {
      return window.epb.pages['dashboard'].sections['dashboard-guide']['image-2'].file_url
    }
  },
  methods: {
    handleDrag({ target, transform }) {
      let ogTransform = target.style.transform

      target.style.transform = transform

      let bounding = target.getBoundingClientRect()
      if (bounding.top < 0) {
        target.style.transform = ogTransform
      }
    },
    toggleModal() {
      this.$emit('toggleDashboardGuideModal')
    },
    printFrame() {
      frames['dashboard-guide'].print()
    }
  }
}
</script>
